import React, { useState, useEffect } from "react";
import { Box, Button, Stack, Typography, IconButton, Tooltip, Drawer, FormControl, Select, InputLabel, MenuItem } from "@mui/material";
import '../../Laboratory/Purchase/purchase.css';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { DataGrid } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { AmountFormat, CheckAccessFunc, CheckCashCounterAccess, formatDate } from "../../../Components/CommonFunctions/CommonFunctions";
import CommonGridHeader, { CommonGridToolBarWithFilterText, CommonPatientDetails } from "../../../Components/Common Components/CommonComponents";
import { CurrencySymbol } from "../../../Utility/Constants";
import { AmountsCard } from "../../../Components/CommonCards/CommonCards";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import CommonDatePicker from "../../../Components/Common Components/CommonDatePicker";
import { DateTime } from "luxon";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const PatientProvider = () => {
    const { t } = useTranslation();
    const [PatientData, setPatientData] = useState([]);
    const [pageSize, setPageSize] = useState(30);
    const [currentPage, setCurrentPage] = useState(0);
    const [isLoader, setIsLoader] = useState(false);
    const [states, setStates] = useState({
        totalAmount: 0,
        totalReceivedAmount: 0,
        totalOutstanding: 0,
        totalCount: 0,
        disableBtn: false,
        pageLength: 0
    });
    const [Filter, setFilter] = useState({
        openFilter: false,
        fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        dateIndex: 1,
    });
    const [selectedStatus, setselectedStatus] = useState("pending");
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const history = useHistory();
    const EditAccess = CheckAccessFunc("front_office", "Credit Settlement", "Corporate Provider", null, "Tab")?.editAccess

    useEffect(() => {
        getPatientList();
    }, [currentPage, pageSize]);

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
    }

    const getPatientList = () => {
        try {
            setIsLoader(true);
            setPatientData([]);

            RestAPIService.getAll(`${Serviceurls.PATIENT_PROVIDER_INFO_GET}?from_date=${Filter?.fromDate}&to_date=${Filter?.toDate}&page_size=${+pageSize}&page_number=${+currentPage + 1}&status=${selectedStatus === "All" ? "" : selectedStatus}`)
                .then(response => {
                    if (response.data.status === "success") {
                        setPatientData(response.data.data);
                        setStates(prev => ({
                            ...prev,
                            totalCount: response?.data?.total_count || 0,
                            totalAmount: response.data?.total_net_amount || 0,
                            totalOutstanding: response.data?.total_pending_amount || 0,
                            totalReceivedAmount: response.data?.total_received_amount || 0,
                            pageLength: response.data?.no_of_pages || 0,
                        }));
                    }
                    setIsLoader(false);
                })
                .catch(error => {
                    setIsLoader(false);
                    if (error.response?.data?.status === "fail") {
                        errorMessage(error.response.data.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message)
            setIsLoader(false);
        }
    };

    const handleView = (row) => {
        history?.push({ pathname: "/HospitalBilling/CashCounter", states: { patient_details: { ...row, patient_account_number: row?.uhid }, return_path: "/CreditSettlement/PatientProvider", back_button_lable: "Back to Credit Settlement", module: (row?.module_type === "IP" ? "ip" : row?.module_type === "OP" ? "op" : "self"), search_label: (row?.module_type === "IP" ? "ip_admission_id" : row?.module_type === "OP" ? "appointment_id" : "patient_id"), search_value: ((row?.module_type === "IP" || row?.module_type === "OP") ? row?.module_id : row?.module_number) } })
    };

    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const getPatientDetailedBillPrint = (id) => {
        try {
            setStates(prev => ({ ...prev, disableBtn: true }));
            RestAPIService.getAll(`${Serviceurls.PURCHASE_VENDOR_PAYMENT}?export_type=pdf`).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    setStates(prev => ({ ...prev, disableBtn: false }));
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        errorMessage(error.response?.data?.message);
                    } else {
                        errorMessage(error.message);
                    }
                    setStates(prev => ({ ...prev, disableBtn: false }));
                });
        } catch (error) {
            errorMessage(error.message);
            setStates(prev => ({ ...prev, disableBtn: false }));
        }
    };

    const printPatientPaymentList = (id) => {
        try {
            setStates(prev => ({ ...prev, disableBtn: false }));
            RestAPIService.getAll(`${Serviceurls.PURCHASE_VENDOR_PAYMENT_PRINT}?vendor_id=${id ? id : ""}&export=pdf`)
                .then(response => {
                    const file = new Blob([response.data], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    setStates(prev => ({ ...prev, disableBtn: false }));
                })
                .catch((error) => {
                    if (error.response?.data?.message) {
                        errorMessage(error.response?.data?.message);
                    } else {
                        errorMessage(error.message);
                    }
                    setStates(prev => ({ ...prev, disableBtn: false }));
                })
        } catch (error) {
            errorMessage(error.message)
            setStates(prev => ({ ...prev, disableBtn: false }));
        }
    }

    const getPatientPaymentexcel = () => {
        try {
            RestAPIService.excelGet(`${Serviceurls.PATIENT_PROVIDER_INFO_GET}?from_date=${Filter?.fromDate}&to_date=${Filter?.toDate}&status=${selectedStatus}&export_type=excel`)
                .then(response => {
                    if (response.data) {
                        const pom = document.createElement('a');
                        const csvContent = response.data;
                        const filename = response.headers["content-disposition"].split("filename=")[1];
                        const blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' });
                        const url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename || 'registry.xlsx');
                        pom.click();
                    }
                }).catch(error => {
                    errorMessage(error?.response?.data?.message);
                });
        } catch (error) {
            errorMessage(error?.message);
        }
    };

    const closeFilter = () => {
        setFilter(prev => ({ ...prev, openFilter: false }));
    }

    const FilterDate = (fromDate, toDate, dateIndex) => {
        setFilter(prev => ({
            ...prev,
            fromDate: fromDate,
            toDate: toDate,
            dateIndex: dateIndex
        }));
    }

    const renderFilterScreen = () => {
        return (
            <Box component="div" className='eMed_rts_filter_container'>
                <Box component="div" className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t('Filter')}</Typography>
                    <Button
                        emed_tid="vndpay_close"
                        onClick={() => setFilter(prev => ({ ...prev, openFilter: false }))}
                        className='eMed_usrconf_btn'
                    >
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>

                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter_vendor'>
                        <CommonDatePicker
                            FromDate={Filter.fromDate}
                            ToDate={Filter.toDate}
                            DateIndex={Filter.dateIndex}
                            SelectedDates={FilterDate}
                            HideAllMenu={false}
                        />
                    </Box>
                    <FormControl sx={{ width: '100%' }} size="small">
                        <InputLabel id="group-select">{t('Status')}</InputLabel>
                        <Select
                            labelId="group-select"
                            id="demo-simple-select"
                            value={selectedStatus}
                            label={t('Status')}
                            onChange={(event) => setselectedStatus(event.target.value)}
                        >
                            <MenuItem value="All">{'All'}</MenuItem>
                            <MenuItem value="pending">{'Pending'}</MenuItem>
                            <MenuItem value="completed">{"Completed"}</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <Stack spacing={2} direction="row" className='eMed_rts_btn' alignItems="center" justifyContent="center">
                    <Button
                        variant='outlined'
                        size="small"
                        emed_tid="fil_clear"
                        onClick={() => {
                            setFilter({
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1
                            });
                            setTimeout(() => {
                                getPatientList();
                            }, 500);
                        }}
                        id="eMed_Config_btn"
                    >
                        {t("Clear")}
                    </Button>
                    <Button
                        variant='contained'
                        size="small"
                        emed_tid="fil_search"
                        onClick={() => {
                            getPatientList();
                            setFilter(prev => ({ ...prev, openFilter: false }));
                        }}
                        id="eMed_Config_btn"
                    >
                        {t("Search")}
                    </Button>
                </Stack>
            </Box>
        );
    };

    const gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(Filter.fromDate) },
            { label: "To Date", value: formatDate(Filter.toDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} noExport={true} />
            </Box>
        )
    }

    const renderTable = () => {
        PatientData.forEach((element, index) => {
            let page = currentPage
            let serial = (page * pageSize) + (index + 1)
            element.serial = serial
        })
        const columns = [
            { field: 's.no', headerClassName: 'grid--header', headerName: t('SNo'), flex: 0.01, sortable: false, hideable: false, renderCell: (params) => (<Box component={'div'}>{params?.row?.serial ? params?.row?.serial : "-"}</Box>) },
            {
                field: 'patient_name', headerClassName: 'grid--header', headerName: t('Patient Details'), flex: 0.2, sortable: false,
                renderCell: (params) => (<Box component={'div'}><CommonPatientDetails data={params.row} disablePhoto={true}/>
                </Box>), valueGetter: (params) => {
                    const name = params.row?.patient_name || "";
                    const mobile = params.row?.mobile_no || "";
                    const UHID = params.row?.uhid || "";
                    return `${name} ${mobile} ${UHID}`;
                }
            },
            {
                field: 'module_type', headerClassName: 'grid--header', headerName: t('Module'), flex: 0.08, sortable: false, type: "number", headerAlign: "center", align: "center",
                renderCell: (params) => (<div style={{ fontWeight: 600 }}>{params?.row?.module_type || "-"}</div>)
            },
            {
                field: 'count', headerClassName: 'grid--header', headerName: t('No Of Bills'), flex: 0.08, sortable: false, type: "number",
                renderCell: (params) => (<div>{params?.row?.count || "-"}</div>)
            },
            {
                field: 'net_amount', headerClassName: 'grid--header', headerName: `${t("Total Amount")} (${CurrencySymbol})`, flex: 0.175, sortable: false, type: "number",
                renderCell: (params) => (<div>{AmountFormat(params?.row?.net_amount || 0).replace(`${CurrencySymbol}`, "")}</div>)
            },
            {
                field: 'received_amount', headerClassName: 'grid--header', headerName: `${t("Received Amount")} (${CurrencySymbol})`, flex: 0.125, sortable: false, type: "number",
                renderCell: ({ row }) => (<div>{AmountFormat(row?.received_amount || 0).replace(`${CurrencySymbol}`, "")}</div>)
            },
            {
                field: 'pending_amount', headerClassName: 'grid--header', headerName: `${t("OutStandingAmount")} (${CurrencySymbol})`, flex: 0.142, sortable: false, type: "number",
                renderCell: (cellvalues) => {
                    let total_balance_amount = AmountFormat(cellvalues.row["pending_amount"] || 0);
                    return (
                        <Typography sx={{ color: +cellvalues.row["pending_amount"] === 0 ? "#1E972A" : "#B82121" }}>
                            {total_balance_amount.replace(`${CurrencySymbol}`, "")}
                        </Typography>
                    );
                }
            },
            {
                field: 'status', headerClassName: 'grid--header', headerName: `${t("Status")}`, flex: 0.125, sortable: false, type: "number",
                renderCell: ({ row }) => (<div>{(row?.pending_amount == 0 ? "Completed" : "Pending")}</div>)
            },
            {
                field: 'actions', headerClassName: 'grid--header', headerName: t('Action'), type: 'actions', flex: 0.125, sortable: false, hideable: false,
                renderCell: ({ row }) => (
                    <>
                        {/* <Tooltip title={t("Print")} placement="top" arrow>
                        <div>
                            <Button emed_tid="Print_invoice" className='eMed_usrconf_btn' disabled={states.disableBtn} onClick={() => { getPatientDetailedBillPrint() }}>
                                <img src={ImagePaths.PrintIcons.default} alt="cart" className='eMed_action_img' />
                            </Button>
                        </div>
                    </Tooltip> */}
                        <Tooltip title={t("Payback")} placement="top" arrow>
                            <IconButton disabled={!EditAccess || row?.pending_amount == 0 || !CheckCashCounterAccess()} size="small" sx={{ borderRadius: "0.3vw" }} onClick={() => handleView(row)}>
                                <img className="emedhub_vendor_img2" src={ImagePaths.Wallet.default} alt="Wallet" style={{ filter: row?.pending_amount == 0 || !EditAccess || !CheckCashCounterAccess() ? 'invert(20%) sepia(0%) saturate(0%) hue-rotate(180deg) brightness(100%) contrast(100%)' : 'none', opacity: 0.8 }} />
                            </IconButton>
                        </Tooltip>
                    </>
                )
            }
        ];
        return (
            <div id="emedhub_ventor_Table" style={{ margin: "0vw 1vw", height: "63vh" }}>
                <DataGrid
                    rows={PatientData}
                    columns={columns}
                    hideFooterSelectedRowCount
                    getRowId={(row) => row.id}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "53vh" }}>
                                {t("NoRecordsFound")}
                            </Stack>
                        )
                    }}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    onCellClick={handleCellClick}
                    onRowClick={handleCellClick}
                    rowCount={states?.pageLength}
                    page={currentPage}
                    loading={isLoader}
                    onPageChange={(newPage) => setCurrentPage(newPage)}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    paginationMode="server"
                />
            </div>
        )
    }

    return (
        <Box className="emedhub__purchase_page" sx={{ '& .grid--header': { backgroundColor: '#FAF9F9' } }}>
            <Box className='eMed_Pharma_rts_header'>
                <Box flex={0.8} display="flex">
                    {AmountsCard("Total Count", states.totalCount, true, "white", false, null)}
                    {AmountsCard("Total Bill Amount", states.totalAmount, false, "white", false, null)}
                    {AmountsCard("Total Received", states.totalReceivedAmount, false, "white", false, null)}
                    {AmountsCard("Total OutStanding", states.totalOutstanding, false, "white", false, null)}
                </Box>
                <Box flex={0.2} display="flex" justifyContent="flex-end" alignItems="center" marginRight="0.5vw">
                    <Tooltip title="Filter" placement='top' arrow>
                        <Button className='eMed_usrconf_btn' onClick={() => { setFilter(prev => ({ ...prev, openFilter: true })) }}>
                            <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                        </Button>
                    </Tooltip>
                    <Tooltip title={t("Export")} placement="top" arrow>
                        <Button onClick={getPatientPaymentexcel} disabled={states.disableBtn} className='eMed_usrconf_btn'>
                            <img src={ImagePaths.ExportIcon.default} alt="upload" className='eMed_action_img' />
                        </Button>
                    </Tooltip>
                    {/* <Tooltip title="Print" placement="top" arrow>
                        <Button emed_tid="vndpay_print" className="eMed_usrconf_btn" disabled={states.disableBtn} onClick={printPatientPaymentList}>
                            <img src={ImagePaths.LabPrintIcon.default} alt="print" className="eMed_action_img" style={{ height: '2.3vw', width: '2.3vw' }} />
                        </Button>
                    </Tooltip> */}
                </Box>
            </Box>
            {renderTable()}
            <Drawer
                anchor={'right'}
                open={Filter.openFilter}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    );
};

export default PatientProvider;
